import { Band, type LessonsOverviewReportData } from 'teacher-ui-client/components/reporting/performance-overview'
import type { ResultsReportData } from 'teacher-ui-client/components/reporting/lesson-performance/results'

export const lessonPerformanceOverview: OmitStrict<LessonsOverviewReportData, 'meta'> = {
  overview: {
    average_lesson_performance: [
      {
        band: Band.Below,
        total_students: 20,
      },
      {
        band: Band.At,
        total_students: 20,
      },
      {
        band: Band.Above,
        total_students: 10,
      },
    ],
    total_students: 50,
  },
}

export const lessonPerformanceResults: OmitStrict<ResultsReportData, 'meta'> = {
  aggregate: {
    total_students: 50,
  },
  results: [
    {
      attempts: 3,
      best_score: 100,
      first_name: 'Bruce',
      grade: '3',
      last_name: 'Wayne',
      teachers: ['teacher-1'],
    },
    {
      attempts: 5,
      best_score: 90,
      first_name: 'D.',
      grade: '2',
      last_name: 'Grayson',
      teachers: ['teacher-1', 'teacher-2', 'teacher-3'],
    },
    {
      attempts: 6,
      best_score: 50,
      first_name: 'Jason',
      grade: '2',
      last_name: 'Todd',
      teachers: ['teacher-1'],
    },
    {
      attempts: 2,
      best_score: 80,
      first_name: 'Tim',
      grade: '1',
      last_name: 'Drake',
      teachers: ['teacher-1'],
    },
    {
      attempts: 2,
      best_score: 70,
      first_name: 'Barbara',
      grade: '3',
      last_name: 'Gordon',
      teachers: ['teacher-1'],
    },
    {
      attempts: 8,
      best_score: 30,
      first_name: 'Damian',
      grade: 'K',
      last_name: 'Wayne',
      teachers: ['teacher-1'],
    },
  ],
}
